/**
 * LOOKBOOK Gallery - Lightbox & Navigation
 */

class LookbookGallery {
  constructor() {
    this.lightbox = document.getElementById('lookbookLightbox');
    this.lightboxImage = this.lightbox?.querySelector('.lookbook-lightbox__image');
    this.closeBtn = this.lightbox?.querySelector('.lookbook-lightbox__close');
    this.prevBtn = this.lightbox?.querySelector('.lookbook-lightbox__prev');
    this.nextBtn = this.lightbox?.querySelector('.lookbook-lightbox__next');
    this.galleryItems = document.querySelectorAll('.lookbook-gallery__item');
    this.currentIndex = 0;
    this.images = [];

    if (!this.lightbox || this.galleryItems.length === 0) return;

    this.init();
  }

  init() {
    // 画像データを収集
    this.galleryItems.forEach((item, index) => {
      const img = item.querySelector('.lookbook-gallery__image');
      if (img) {
        this.images.push({
          src: img.src,
          srcset: img.srcset,
          alt: img.alt || ''
        });

        // クリックイベント
        item.addEventListener('click', () => {
          this.openLightbox(index);
        });
      }
    });

    // ナビゲーションボタン
    this.closeBtn?.addEventListener('click', () => this.closeLightbox());
    this.prevBtn?.addEventListener('click', () => this.showPrevImage());
    this.nextBtn?.addEventListener('click', () => this.showNextImage());

    // 背景クリックで閉じる
    this.lightbox.addEventListener('click', (e) => {
      if (e.target === this.lightbox) {
        this.closeLightbox();
      }
    });

    // キーボード操作
    document.addEventListener('keydown', (e) => {
      if (!this.lightbox.classList.contains('active')) return;

      switch(e.key) {
        case 'Escape':
          this.closeLightbox();
          break;
        case 'ArrowLeft':
          this.showPrevImage();
          break;
        case 'ArrowRight':
          this.showNextImage();
          break;
      }
    });
  }

  openLightbox(index) {
    this.currentIndex = index;
    this.updateImage();
    this.lightbox.classList.add('active');
    document.body.classList.add('lookbook-lightbox-open');
  }

  closeLightbox() {
    this.lightbox.classList.remove('active');
    document.body.classList.remove('lookbook-lightbox-open');
  }

  showPrevImage() {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    this.updateImage();
  }

  showNextImage() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
    this.updateImage();
  }

  updateImage() {
    const currentImage = this.images[this.currentIndex];
    if (!currentImage) return;

    // ローディング状態を追加
    this.lightboxImage.classList.add('loading');
    
    // 画像をプリロード
    const img = new Image();
    img.onload = () => {
      this.lightboxImage.src = currentImage.src;
      this.lightboxImage.srcset = currentImage.srcset || '';
      this.lightboxImage.alt = currentImage.alt;
      this.lightboxImage.classList.remove('loading');
      
      // 次の画像をプリロード
      this.preloadNextImages();
    };
    img.onerror = () => {
      this.lightboxImage.classList.remove('loading');
    };
    
    // 読み込み開始
    if (currentImage.srcset) {
      img.srcset = currentImage.srcset;
    }
    img.src = currentImage.src;

    // ナビゲーションボタンの表示/非表示
    if (this.images.length <= 1) {
      this.prevBtn.style.display = 'none';
      this.nextBtn.style.display = 'none';
    } else {
      this.prevBtn.style.display = 'block';
      this.nextBtn.style.display = 'block';
    }
  }

  preloadNextImages() {
    // 次と前の画像をプリロード
    const nextIndex = (this.currentIndex + 1) % this.images.length;
    const prevIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    
    [nextIndex, prevIndex].forEach(index => {
      const image = this.images[index];
      if (image && !image.preloaded) {
        const img = new Image();
        if (image.srcset) img.srcset = image.srcset;
        img.src = image.src;
        image.preloaded = true;
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new LookbookGallery();
  });
} else {
  new LookbookGallery();
}
